import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import logo2 from "../assests/images/logo2.png";
// import sign from "../assests/images/sign.png";
import RobotoBold from "../assests/fonts/Roboto-ExtraBold.ttf";

Font.register({
  family: "Roboto", // Register the font family name
  fonts: [
    { src: RobotoBold, fontWeight: 700 }, // Reference the local file here
  ],
});
// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
    transform: "scale(1)",
  },

  blueBar: {
    backgroundColor: "#1E3A8A",
    width: "25%",
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 2,
    marginBottom: 4,
  },

  blueBarText: {
    color: "white",
    fontSize: 14,
    textAlign: "center",
    marginVertical: 1,
    fontFamily: "Roboto",
    fontWeight: "extrabold",
  },
  headerBox: {
    border: "1.5pt solid #000",
    padding: 4,
    borderRadius: 6,
    marginBottom: 4,
    height: 80,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerLeft: {
    width: "25%",
    alignItems: "flex-start",
  },
  headerCenter: {
    width: "60%",
    textAlign: "center",
  },
  headerRight: {
    width: "20%",
    alignItems: "flex-end",
    position: "relative",
    top: -22,
  },
  logo: {
    width: 50,
    height: 45,
    marginBottom: 4,
    marginLeft: 5,
    marginTop: 5,
  },

  companyName: {
    fontSize: 24,
    fontWeight: "extrabold",
    color: "#003366",
    fontFamily: "Roboto",
  },
  subTitle: {
    fontSize: 12,
    marginBottom: 2,
  },
  companyAddress: {
    fontSize: 10,
    marginLeft: "10px",
  },
  boldBlue: {
    fontWeight: "extrabold",
    color: "#003366",
    fontFamily: "Roboto",
    fontSize: 12, // Deep Blue Color
  },
  phoneText: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#003366",
    fontFamily: "Roboto",
    marginTop: -8,
    marginRight: 5
  },
  gstText: {
    fontSize: 11,
    marginTop: -2,
    fontWeight: "bold",
    fontFamily: "Roboto",
    color: "#003366",
  },
  detailsBox: {
    borderWidth: 1.6,
    borderColor: "#000",
    marginTop: 6,
    paddingVertical: 10,
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  detailsBox1: {
    borderWidth: 1.6,
    borderColor: "#000",
    marginTop: -8,
    paddingVertical: 2,
    borderRadius: 8,
    paddingHorizontal: 5,
  },
  detailsRow: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 1,
    marginBottom: 2,
  },

  lineText: {
    fontSize: 12,
    fontWeight: "normal",
    color: "#003366",
    fontFamily: "Roboto",
    lineHeight: 1.5,
  },
  lineText1: {
    fontSize: 12,
    fontWeight: "normal",
    color: "#030e1aff",
    fontFamily: "Roboto",
    lineHeight: 1.5,
  },

  lineTextBold: {
    fontWeight: "extrabold",
    fontFamily: "Roboto",
  },

  tableContainer: {
    borderLeftWidth: 1,
    // borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    marginTop: 12,
    marginBottom: 20,
    borderStyle: "solid",
  },

  tableRow: {
    //alignItems: "center",
    flexDirection: "row",
    minHeight: 22,
  },

  cell: {
    fontSize: 11,
    borderRightWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    paddingVertical: 4,
    paddingLeft: 4,
  },

  taxCell: {
    paddingVertical: 2,
    minHeight: 1,
    paddingBottom: 0,
    textAlign: "center",
    lineHeight: 0.4,
    fontSize: 10,
    borderColor: "#000",
  },
});

const Pdf = ({ data, units }) => {
  // Destructure for easier access
  const {
    company_details,
    party_name,
    address,
    mobile_number,
    party_details,
    bill_no,
    bill_date,
    vechile_no,
    email_id,
    hsn_code,
    gst_no,
    product,
    total,
    sub_total,
    gst_amount,
    gst_type,
    round_off,
    round_off_amount,
  } = data || {};

  const products = product || [];

  const companyName = company_details?.company_name || "";
  const companyAddress = company_details?.address || "";
  const companyCityState = company_details?.city || "";
  const companyGST = company_details?.gst_no || "";
  const companyPhone = company_details?.mobile_number || "";
  const companyBankName = company_details?.bank_name || "";
  const companyAccNo = company_details?.acc_no || "";
  const companyIFSC = company_details?.ifsc_code || "";

  const customerName = party_name || "";
  const customerAddress = address || "";
  const customerPhone = mobile_number || "";
  const customerGST = party_details?.gst_no || "";
  const vehicleNo = vechile_no || "";
  const billNumber = bill_no || "";
  const emailId = email_id || "";
  const hsnCode = hsn_code || "";
  const billDate = bill_date
    ? new Date(bill_date).toLocaleDateString("en-GB")
    : "N/A";
  const MAX_ROWS = 13;

  const effectiveUnitData = units && units.length > 0 ? units : [];

  const getUnitName = (p) => {
    if (!p) return "";

    // 0. CHECK PRE-RESOLVED FIELD FIRST (MODIFIED)
    if (p.resolved_unit_name) return p.resolved_unit_name.trim();

    // 1. Direct label check (common field names)
    const directName =
      p.unit_name ||
      p.u_name ||
      p.unitname ||
      p.units_name ||
      p.product_unit;
    if (
      directName &&
      typeof directName === "string" &&
      directName.trim().length > 0
    ) {
      return directName.trim();
    }

    // 2. If 'unit' field is already a string label instead of an ID
    if (
      p.unit &&
      typeof p.unit === "string" &&
      isNaN(p.unit) &&
      p.unit.trim().length > 0
    ) {
      return p.unit.trim();
    }

    // 3. Robust ID lookup
    const unitId = p.unit || p.unit_id || p.units_id || p.u_id || p.product_unit_id;
    if (unitId && effectiveUnitData && effectiveUnitData.length > 0) {
      const matchedUnit = effectiveUnitData.find(
        (u) =>
          String(u.unit_id) === String(unitId) ||
          String(u.id) === String(unitId) ||
          String(u.u_id) === String(unitId)
      );
      if (matchedUnit) {
        return (
          matchedUnit.unit_name ||
          matchedUnit.short_name ||
          matchedUnit.name ||
          ""
        ).trim();
      }
    }

    return "";
  };

  const totalQtyValue = products
    .reduce((acc, item) => acc + (parseFloat(item.qty) || 0), 0)
    .toFixed(2);
  
  const totalUnit = products.length > 0 ? getUnitName(products[0]) : "";
  const totalQty = `${totalQtyValue}${totalUnit ? ` ${totalUnit}` : ""}`;
  // Total of Rs (sub_total - discount_amt)
  const totalRs = Math.floor(sub_total || 0);
  const totalPs = ((sub_total || 0) - totalRs) * 100; // Assuming sub_total is the pre-tax total

  const displayItems = products.map((p, index) => ({
    rate: parseFloat(p.price_unit).toFixed(2) || "0.00",
    particulars: p.product_name || "",
    bags: p.unit_count || "",
    batch: p.batch || "",
    qty: p.qty
      ? `${(parseFloat(p.qty) * (p.unit_conversion_factor || 1)).toFixed(2)}${
          getUnitName(p) ? ` ${getUnitName(p)}` : ""
        }`
      : "",
    rs: Math.floor(parseFloat(p.total_amt)).toString() || "0",
    ps:
      ((parseFloat(p.total_amt) - Math.floor(parseFloat(p.total_amt))) * 100)
        .toFixed(0)
        .padStart(2, "0") || "00",
  }));

  // Pad the dynamic items up to MAX_ROWS
  const paddedDynamicItems = displayItems
    .concat(Array(MAX_ROWS - displayItems.length).fill({}))
    .slice(0, MAX_ROWS);

  const gstAmountValue = parseFloat(gst_amount) || 0;
  const gstTypeFormatted = gst_type || "GST@0%";
  const taxData = [];

  if (gstAmountValue > 0) {
    const gstAmountRs = Math.floor(gstAmountValue).toString();
    const gstAmountPs = ((gstAmountValue - Math.floor(gstAmountValue)) * 100)
      .toFixed(0)
      .padStart(2, "0");

    // Extract the GST rate (e.g., from "GST@5%" get 5)
    const totalRateMatch = gstTypeFormatted.match(/@(\d+)\%$/);
    const totalRate = totalRateMatch ? parseFloat(totalRateMatch[1]) : 0;

    if (gstTypeFormatted.startsWith("GST@")) {
      // Intra-state (CGST + SGST) - Split the total GST amount and rate
      const halfGst = gstAmountValue / 2;
      const halfRate = (totalRate / 2).toFixed(1);

      const halfRs = Math.floor(halfGst).toString();
      const halfPs = ((halfGst - Math.floor(halfGst)) * 100)
        .toFixed(0)
        .padStart(2, "0");

      // Use the calculated name and amounts
      taxData.push({ name: `SGST ${halfRate}%`, rs: halfRs, ps: halfPs });
      taxData.push({ name: `CGST ${halfRate}%`, rs: halfRs, ps: halfPs });

    } else if (gstTypeFormatted.startsWith("IGST@")) {
      // Inter-state (IGST only)
      // Use the full rate and amount
      taxData.push({
        name: `IGST ${totalRate}%`,
        rs: gstAmountRs,
        ps: gstAmountPs
      });
    }
  }

  // --- Round Off Calculation ---
  const [roundOffRs, roundOffPs] = parseFloat(round_off_amount || 0)
    .toFixed(2)
    .split(".");

  // Corrected logic to determine finalTaxRows
  const finalTaxRows = (() => {
    if (taxData.length > 0) {
      // Case 1: Tax amount > 0 (CGST/SGST or IGST calculated)
      return taxData;
    }
    // Case 2: Tax amount is 0. Hide rows.
    return [];
  })();
  // --- Dynamic Grand Total ---
  const grandTotal = parseFloat(total) || 0;
  const grandTotalRs = Math.floor(grandTotal);
  const grandTotalPs = ((grandTotal - grandTotalRs) * 100)
    .toFixed(0)
    .padStart(2, "0");

  // --- Rupees in Words ---
  function convertRupeesToWords(amount) {
    // Lookup Arrays
    const a = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    const b = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
    const scales = ["", "thousand", "lakh", "crore"];

    const numToWords = (n) => {
      let str = "";
      const h = Math.floor(n / 100);
      const t = n % 100;

      if (h > 0) str += a[h] + " hundred" + (t > 0 ? " and " : "");
      if (t > 0) {
        str += t < 20 ? a[t] : b[Math.floor(t / 10)] + " " + a[t % 10];
      }
      return str.trim();
    };

    const [rsStr, psStr] = parseFloat(amount).toFixed(2).split(".");
    const rs = parseInt(rsStr, 10);
    const ps = parseInt(psStr, 10);
    let result = [];

    if (rs === 0 && ps === 0) return "ZERO RUPEES ONLY";

    let num = rs;
    let i = 0;
    while (num > 0) {
      let chunk;
      let scale = scales[i];

      chunk = i === 0 ? num % 1000 : num % 100;
      num = i === 0 ? Math.floor(num / 1000) : Math.floor(num / 100);

      if (chunk > 0) {
        let words = numToWords(chunk);
        if (scale) words += " " + scale;
        result.unshift(words.trim());
      }
      i++;
    }

    let finalWords = result.join(" ").toUpperCase().trim();
    if (finalWords) finalWords += " RUPEES";

    // 2. Convert Paise (Ps) part
    if (ps > 0) {
      const psWords = numToWords(ps);
      if (finalWords) finalWords += " AND ";
      finalWords += psWords.toUpperCase() + " PAISE";
    }

    return finalWords.trim() + " ONLY";
  }

  const words = convertRupeesToWords(grandTotal);
  const [userdata, setUserData] = useState([]);

  const filteredUserData = userdata.filter(
    (item) => item.company_id === data.party_details?.company_id
  );

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      //setLoading(false);
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      //setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);


  return (
    <Document>
      <Page size="A4" wrap style={styles.page}>
        {/* Top Blue Bar */}
        <View style={styles.blueBar}>
          <Text style={styles.blueBarText}>TAX INVOICE</Text>
          <Text style={styles.blueBarText}>CASH / CREDIT BILL</Text>
        </View>

        {/* Company Info */}
        <View style={styles.headerBox}>
          <View style={styles.headerRow}>
            <View style={styles.headerLeft}>
              <Text style={styles.gstText}>GST: {companyGST}</Text>
              <Image src={logo2} style={styles.logo} />
            </View>

            <View style={styles.headerCenter}>
              <Text style={[styles.companyName, { marginTop: 4 }]}>
                {companyName}
              </Text>
              <Text style={styles.subTitle}>
                (Splints & Veneers & Soft Wood)
              </Text>
              <Text style={[styles.companyAddress, { whiteSpace: "nowrap" }]}>
                {companyAddress}
                <Text style={styles.boldBlue}>{companyCityState}</Text>
              </Text>
              <Text style={styles.companyAddress}>
                {/* Email not in company_details, using placeholder */}
                E-mail: sdrvicky6@gmail.com
              </Text>
            </View>

            <View style={styles.headerRight}>
              <Text style={styles.phoneText}>{companyPhone}</Text>
            </View>
          </View>
        </View>

        {/* Customer / Bill Details Box */}
        <View style={styles.detailsBox}>
          <View style={styles.detailsRow}>
            <Text
              style={[styles.lineText, { width: "50%", flexWrap: "nowrap" }]}
            >
              <Text style={styles.lineTextBold}>M/s: </Text>
              {customerName}
            </Text>
            <View
              style={{
                width: "50%",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={[styles.lineText, { width: "45%" }]}>
                Bill No: {billNumber}
              </Text>
              <Text
                style={[styles.lineText, { width: "50%", textAlign: "right" }]}
              >
                Date: {billDate}
              </Text>
            </View>
          </View>

          <View style={styles.detailsRow}>
            <Text style={[styles.lineText, { width: "50%" }]}>
              Address: {customerAddress}
            </Text>
            <Text style={[styles.lineText, { width: "50%" }]}>
              Party’s GSTIN: {customerGST || "-"}
            </Text>
          </View>

          <View style={styles.detailsRow}>
            <Text style={[styles.lineText, { width: "50%" }]}>
              Phone: {customerPhone}
            </Text>
            <Text style={[styles.lineText, { width: "50%" }]}>
              Vehicle No: {vehicleNo || "-"}
            </Text>
          </View>
          {/* Row 4: Other Detail and HSN Code */}
          <View style={styles.detailsRow}>
            {/* Left 50%: Conditional rendering for Email */}
            {emailId ? (
              <Text style={[styles.lineText, { width: "50%" }]}>
                Email: {emailId}
              </Text>
            ) : (
              // If emailId is empty/null, render an empty Text component to act as a spacer
              <Text style={{ width: "50%" }}></Text>
            )}

            {/* Right 50%: Conditional rendering for HSN Code */}
            {hsnCode ? (
              <Text style={[styles.lineText, { width: "50%" }]}>
                HSN Code: {hsnCode}
              </Text>
            ) : (
              // If hsnCode is empty/null, render an empty Text component to act as a spacer
              <Text style={{ width: "50%" }}></Text>
            )}
          </View>
          {/* Row 4: Other Detail and HSN Code */}
          {/* <View style={styles.detailsRow}>
            <Text style={[styles.lineText, { width: "50%" }]}>
              Email: {emailId || "-"}
            </Text>
            <Text style={[styles.lineText, { width: "50%" }]}>
              HSN Code: {hsnCode || "-"}
            </Text>
          </View> */}
        </View>

        {/* Table Header */}

        <View style={[styles.tableContainer]}>
          <View style={{ borderColor: "#000" }}>
            {/* Row 1: Main Headers (RATE, PARTICULARS, QTY, AMOUNT) */}
            <View style={{ flexDirection: "row" }}>
              <Text
                style={{
                  width: "20%",
                  textAlign: "center",
                  color: "#030e1aff",
                  fontFamily: "Roboto",
                  fontSize: 13,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  paddingVertical: 4,
                  borderTopWidth: 1,
                  borderBottomWidth: 1,
                }}
              >
                RATE
              </Text>

              <Text
                style={{
                  width: "30%",
                  textAlign: "center",
                  borderRightWidth: 1,
                  color: "#030e1aff",
                  fontFamily: "Roboto",
                  fontSize: 13,
                  borderColor: "#000",
                  fontWeight: "extrabold",
                  paddingVertical: 4,
                  borderTopWidth: 1,
                  borderBottomWidth: 1,
                }}
              >
                PARTICULARS
              </Text>

              <Text
                style={{
                  width: "12%",
                  textAlign: "center",
                  borderRightWidth: 1,
                  color: "#030e1aff",
                  fontFamily: "Roboto",
                  fontSize: 13,
                  borderColor: "#000",
                  paddingVertical: 4,
                  borderTopWidth: 1,
                  borderBottomWidth: 1,
                }}
              >
                BAGS
              </Text>

              <Text
                style={{
                  width: "13%",
                  textAlign: "center",
                  borderRightWidth: 1,
                  color: "#030e1aff",
                  fontFamily: "Roboto",
                  fontSize: 13,
                  borderColor: "#000",
                  paddingVertical: 4,
                  borderTopWidth: 1,
                  borderBottomWidth: 1,
                }}
              >
                QUANTITY Qt.
              </Text>

              {/* AMOUNT section (This section naturally has the line built-in) */}
              <View style={{ width: "25%" }}>
                <Text
                  style={{
                    textAlign: "center",
                    borderBottomWidth: 1,
                    borderColor: "#000",
                    color: "#030e1aff", // Dark blue color for the entire line
                    fontFamily: "Roboto",
                    fontSize: 13,
                    borderRightWidth: 1,
                    paddingVertical: 2,
                    borderTopWidth: 1,
                  }}
                >
                  AMOUNT
                </Text>

                {/* Row 2: Rs./Ps. Sub-headers */}

                <View
                  style={{
                    flexDirection: "row",
                    borderBottomWidth: 1,
                    borderColor: "#000",
                  }}
                >
                  <Text
                    style={{
                      width: "80%",
                      textAlign: "center",
                      borderRightWidth: 1,
                      color: "#030e1aff", // Dark blue color for the entire line
                      // fontFamily: "Roboto",
                      fontSize: 13,
                      borderColor: "#000",
                      paddingVertical: 2,
                    }}
                  >
                    Rs.
                  </Text>
                  <Text
                    style={{
                      width: "20%",
                      borderRightWidth: 1,
                      color: "#030e1aff", // Dark blue color for the entire line
                      // fontFamily: "Roboto",
                      fontSize: 13,
                      textAlign: "center",
                      paddingVertical: 2,
                    }}
                  >
                    Ps.
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* --- Dynamic Data Rows --- */}
          {paddedDynamicItems.map((item, i) => (
            <View key={i} style={styles.tableRow}>
              <Text
                style={[
                  styles.cell,

                  {
                    width: "20%",
                    borderBottomWidth: 0,
                  },
                ]}
              >
                {item.rate
                  ? `Rs.${item.rate.replace(/\.00$/, "")}`
                  : ""}
              </Text>

              <Text
                style={[
                  styles.cell,
                  {
                    width: "30%",
                    borderBottomWidth: 0,
                  },
                ]}
              >
                {item.particulars}
              </Text>

              <Text
                style={[
                  styles.cell,
                  {
                    width: "12%",
                    textAlign: "center",

                    borderBottomWidth: 0,
                  },
                ]}
              >
                {item.batch}
              </Text>

              <Text
                style={[
                  styles.cell,
                  {
                    width: "13%",
                    textAlign: "center",

                    borderBottomWidth: 0,
                  },
                ]}
              >
                {item.qty}
              </Text>

              <Text
                style={[
                  styles.cell,
                  {
                    width: "20%",
                    borderBottomWidth: 0,
                    textAlign: "center",
                    justifyContent: "center",
                  },
                ]}
              >
                {item.rs}
              </Text>

              <Text
                style={[
                  styles.cell,
                  {
                    width: "5%",
                    borderRightWidth: 1,
                    borderBottomWidth: 0,
                  },
                ]}
              >
                {item.ps}
              </Text>
            </View>
          ))}
          {/* --- Dynamic SGST / CGST / IGST Rows --- */}
          {finalTaxRows.map((tax, index) => (
            <View
              key={index}
              style={[
                styles.tableRow,
                // {
                //   minHeight: 18,
                //   borderColor: "#000",
                // },
              ]}
            >
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "20%",
                    paddingRight: 6,

                    borderBottomWidth: 0, // Keep 0 border on Text to avoid double line
                    alignItems: "center",
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "30%",
                    textAlign: "right",
                    fontSize: 12,
                    paddingRight: 3,
                  },
                ]}
              >
                {tax.name}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "12%",
                    textAlign: "center",
                    borderBottomWidth: index === 0 ? 1 : 0,
                    borderTopWidth: index === 0 ? 1 : 0,
                    borderRightWidth: 1,
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "13%",
                    borderBottomWidth: index === 0 ? 1 : 0,
                    borderTopWidth: index === 0 ? 1 : 0,
                    borderRightWidth: 1,
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "20%",
                    borderBottomWidth: 0,
                    borderRightWidth: 1,
                    textAlign: "center",
                    paddingHorizontal: 2,
                    borderBottomWidth: index === 0 ? 1 : 0,
                    borderTopWidth: index === 0 ? 1 : 0,
                    justifyContent: "center",
                  },
                ]}
              >
                {tax.rs}
              </Text>
              <Text
                style={[
                  styles.cell,
                  {
                    width: "5%",
                    paddingVertical: 2,
                    paddingHorizontal: 4,
                    textAlign: "center",
                    justifyContent: "center",
                    borderTopWidth: index === 0 ? 1 : 0,
                    lineHeight: 0.4,
                    borderRightWidth: 1,
                    borderBottomWidth: index === 0 ? 1 : 0,
                  },
                ]}
              >
                {tax.ps}
              </Text>
            </View>
          ))}

          {/* --- Round Off Row --- */}
          {(parseInt(round_off) === 1 || round_off === 1) && (
            <View style={styles.tableRow}>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "20%",
                    borderBottomWidth: 0,
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "30%",
                    textAlign: "right",
                    fontSize: 12,
                    paddingRight: 3,
                   
                  },
                ]}
              >
                Round Off
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "12%",
                    borderTopWidth: finalTaxRows.length === 0 ? 1 : 0,
                    borderBottomWidth: 0,
                    borderRightWidth: 1,
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "13%",
                    borderTopWidth: finalTaxRows.length === 0 ? 1 : 0,
                    borderBottomWidth: 0,
                    borderRightWidth: 1,
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.cell,
                  styles.taxCell,
                  {
                    width: "20%",
                    borderTopWidth: finalTaxRows.length === 0 ? 1 : 0,
                    borderBottomWidth: 0,
                    borderRightWidth: 1,
                    textAlign: "center",
                    justifyContent: "center",
                    paddingHorizontal: 2,
                  },
                ]}
              >
                {roundOffRs}
              </Text>
              <Text
                style={[
                  styles.cell,
                  {
                    width: "5%",
                    paddingVertical: 2,
                    borderTopWidth: finalTaxRows.length === 0 ? 1 : 0,
                    paddingHorizontal: 4,
                    textAlign: "center",
                    justifyContent: "center",
                    lineHeight: 0.4,
                    borderRightWidth: 1,
                    borderBottomWidth: 0,
                  },
                ]}
              >
                {roundOffPs}
              </Text>
            </View>
          )}

          <View style={[styles.tableRow, { minHeight: 18 }]}>
            {/* RATE Column: No top or bottom horizontal line */}
            <Text
              style={[styles.cell, { width: "20%", borderBottomWidth: 0 }]}
            ></Text>

            {/* PARTICULARS TOTAL Cell: No horizontal lines */}
            <Text
              style={[
                styles.cell,
                {
                  width: "30%",
                  textAlign: "right",
                  paddingRight: 6,
                  fontSize: 12,
                  fontFamily: "Roboto",
                  borderBottomWidth: 0,
                },
              ]}
            >
              TOTAL
            </Text>
            {/* Right-Side TOTAL Cells (vertical lines, top horizontal line starts here) */}
            <Text
              style={[
                styles.cell,
                {
                  width: "12%",
                  borderTopWidth: 1,
                  borderBottomWidth: 0,
                  textAlign: "center",
                  paddingHorizontal: 2,
                  justifyContent: "center",
                },
              ]}
            >
              {/* Batch total hidden */}
            </Text>
            <Text
              style={[
                styles.cell,
                {
                  width: "13%",
                  borderTopWidth: 1,
                  borderBottomWidth: 0,
                  textAlign: "center",
                  paddingHorizontal: 2,
                  justifyContent: "center",
                },
              ]}
            >
              {/* Quantity total hidden */}
            </Text>

            {/* Rs. column (Dynamic Grand Total Rs) */}
            <Text
              style={[
                styles.cell,
                {
                  width: "20%",
                  borderTopWidth: 1,
                  borderBottomWidth: 0,
                  textAlign: "center",
                  paddingHorizontal: 2,
                  justifyContent: "center",
                  borderRightWidth: 1,
                },
              ]}
            >
              {grandTotalRs}
            </Text>

            {/* Ps. column (Dynamic Grand Total Ps) */}
            <Text
              style={[
                styles.cell,
                {
                  width: "5%",
                  borderRightWidth: 1,
                  borderTopWidth: 1,
                  textAlign: "center",
                  paddingHorizontal: 2,
                  justifyContent: "center",
                  borderBottomWidth: 0,
                },
              ]}
            >
              {grandTotalPs}
            </Text>
          </View>
        </View>

        <View style={styles.detailsBox1}>
          <View style={styles.detailsRow}>
            <Text style={styles.lineText1}>E.&O.E.</Text>
          </View>

          <View style={styles.detailsRow}>
            <Text style={styles.lineText1}>Rupees in words: {words}</Text>
          </View>
        </View>


      </Page>
    </Document>
  );
};
export default Pdf;
